module.exports = __webpack_public_path__ + "static/media/nequi.cb0a4154.png";